import { routesMap } from '../../../routes/AppRoutes';
import HeroSection from '../../conduct-risk/HeroSection';

interface DataFromParent {
  name: string;
}

const BannerDettaglioBanks = ({ name }: DataFromParent) => (
  <HeroSection
    title={name}
    description="Visualizza i dettagli della banca, aggiorna le sue informazioni e gestisci le sue fonti."
    breadcrumbLinks={[
      { url: routesMap.HOME_PAGE, title: 'Home' },
      { url: routesMap.BEST_EXECUTION_HOME, title: 'Best Execution' },
      { url: routesMap.BANKS_PAGE, title: 'Banks' },
      { url: '#', title: name },
    ]}
  />
);

export default BannerDettaglioBanks;
